// DocSpeaker Actions
import {
  iDocDataUpdateBasePayload,
  namespacePrefix,
} from '../../document.baseType';
import { iDocSpeakerData } from '../docSpeaker.type';

/** Reducer Actions */
// 初始化发言人数据
export const initDocSpeakerDataReducerAction = (
  payload: iDocDataUpdateBasePayload<iDocSpeakerData>,
  isHooks = false,
) => ({
  type: namespacePrefix('initDocSpeakerDataReducer', isHooks),
  payload,
});
/** Effects Actions */
// 初始化发言人数据
export const initDocSpeakerDataAction = (
  payload: iDocDataUpdateBasePayload<null>,
  isHooks = false,
) => ({
  type: namespacePrefix('initDocSpeakerDataEffect', isHooks),
  payload,
});
